import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelsChoiceContainer = styled.div`
  position: fixed;
`;

export default withAnimation(ChannelsChoiceContainer);
